import styled from 'styled-components';

import Text from 'components/Text';

export default styled(Text)`
  font-family: var(--google-sora-cdn);
  text-align: center;
  margin: 20px 0px 10px 0px;
`;
